export default "__VITE_ASSET__CuhNd6Pp__"